import { Contract } from '../contract/contract.model';
import { Course } from '../course/course.model';
import { Staff } from '../staff/staff.model';
import { ActivityRole } from './lib/activity.interfaces';
import { ApiResource } from '../api-resource';
import { Camp } from '../camp/camp.model';
import { Workshop } from '../workshop/workshop.model';
import { Endpoint } from '../api.decorators';
import {
  EnumField,
  Field,
} from '../../util/components/resource/resource-fields/resource-fields';
import { activityRoleLabels } from './lib/activity.util';
import { ContractData } from '../contract/lib/contract.interfaces';
import { createContractDataFormGroup } from '../contract/lib/contract.util';

@Endpoint('activities', 'Activity')
export class Activity extends ApiResource<Activity> {
  @EnumField({
    type: () => ActivityRole,
    label: $localize`Role`,
    enumLabels: activityRoleLabels,
  })
  role!: ActivityRole;

  @Field({ type: () => Staff, label: $localize`Staff` })
  staff!: Staff;

  @Field({ type: () => Contract, label: $localize`Contract` })
  contract?: Contract;

  @Field({
    formControlFactory: createContractDataFormGroup,
    includeFilter: false,
    label: $localize`Contract data`,
  })
  contractData!: ContractData;

  @Field({ type: () => Camp, label: $localize`Camp` })
  camp?: Camp;

  @Field({ type: () => Course, label: $localize`Course` })
  course?: Course;

  @Field({ type: () => Workshop, label: $localize`Workshop` })
  workshop?: Workshop;

  @Field({ type: () => Activity, label: $localize`Main activity` })
  mainActivity?: Activity;

  get target() {
    const target = this.camp ?? this.course ?? this.workshop;
    if (!target) throw new Error(`Activity '${this.id}' is missing a target`);
    return target;
  }

  get rootTarget() {
    const target = this.camp ?? this.course?.camp ?? this.workshop;
    if (!target) {
      let message = `Activity '${this.id}' is missing a root target.`;
      if (this.course) message += ' Has `course` but `course.camp` is absent.';
      throw new Error(message);
    }
    return target;
  }

  override toLabel(): string {
    return `${this.staff.firstName} ${this.staff.lastName} ${this.target.name}`;
  }
}

export type WorkshopActivity = Activity & Required<Pick<Activity, 'workshop'>>;
export type CourseActivity = Activity & Required<Pick<Activity, 'course'>>;
export type CampActivity = Activity & Required<Pick<Activity, 'camp'>>;
